import { useMutation, useQueryClient } from '@tanstack/react-query';
import snakecaseKeys from 'snakecase-keys';
import { useGetUserProfile } from '@telus-alberta-health-web/shared-module';
import { GET_USER_PROFILE_MESSAGE_TYPE } from '@leagueplatform/user-profile-api';
import { setPostFtux, SetPostFtuxPayload } from '../../api/set-post-ftux';

export const useFtuxCompletion = () => {
  const queryClient = useQueryClient();

  const { data, isLoading, error: userProfileError } = useGetUserProfile();
  const updateFtuxMutation = useMutation({
    mutationFn: async (payload: SetPostFtuxPayload) => {
      await setPostFtux(snakecaseKeys(payload));
      await queryClient.invalidateQueries({
        queryKey: [GET_USER_PROFILE_MESSAGE_TYPE],
      });
    },
  });

  const markFtuxComplete = () =>
    updateFtuxMutation.mutateAsync({
      ftuxComplete: true,
    });

  return {
    ftuxComplete: userProfileError ? undefined : data?.ftuxComplete,
    isLoading,
    userProfileError,
    markFtuxComplete,
  };
};
